import { getDefaultExportFromCjs as r } from "./index89.mjs";
import { __require as o } from "./index83.mjs";
var t = o();
const a = /* @__PURE__ */ r(t);
export {
  a as default
};
